module.exports = __webpack_public_path__ + "prod/1.42.2/img/manufacturing-chain.350ef50b.png";